




import { Component, Prop, Vue } from 'vue-property-decorator';
import { DashboardControl, ResourceManager } from 'devexpress-dashboard';
import DevExpress from '@devexpress/analytics-core';
import { DashboardMenuItem, DataSourceWizardExtension } from 'devexpress-dashboard/designer';

@Component
export default class ScreenContents extends Vue {
    private Id: number = 0;
    private ScreenId: number = 0;
    private dashboardControl: any;

    constructor() {
        super();
        this.dashboardControl = {};
    }
    private created() {
        this.Id = parseInt(this.$route.params['id'], 10);
        this.ScreenId = parseInt(this.$route.params['screenId'], 10);
    }
    private mounted() {
        ResourceManager.embedBundledResources();

        const obj: HTMLElement = this.$refs.dcontainer as HTMLElement;

        this.dashboardControl = new DashboardControl(obj, {
        // Specifies the URL where the Web Dashboard's server side is hosted.
            endpoint: this.$store.state.basePath + 'MyDashboard',
            workingMode: 'Designer',
            initialDashboardId: this.Id.toString()
        });

        var toolbox = this.dashboardControl.findExtension('toolbox');
        var wizard = this.dashboardControl.findExtension('data-source-wizard');

        toolbox.removeMenuItem('open-dashboard');
        toolbox.removeMenuItem('create-dashboard');

        wizard.isCustomSqlEnabled = true;

        const exitItem = new DashboardMenuItem('mi_Exit', 'Exit', 10, 0);
        exitItem.click = this.Exit;
        toolbox.addMenuItem(exitItem);
        this.dashboardControl.render();
    }

    private Exit() {
        this.$router.push(`/admin/screens/details/${this.ScreenId}`);
    }
}
